import { render, staticRenderFns } from "./AllMenuSetting.vue?vue&type=template&id=c2d799de&scoped=true"
import script from "./AllMenuSetting.vue?vue&type=script&lang=js"
export * from "./AllMenuSetting.vue?vue&type=script&lang=js"
import style0 from "./AllMenuSetting.vue?vue&type=style&index=0&id=c2d799de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d799de",
  null
  
)

export default component.exports